import { useEffect, useMemo, useState } from "react";
import { useI18n } from "@/hooks/useI18n";
import {
  WHITELIST_AUTH_TYPE,
  WHITELIST_CATEGORY,
  WHITELIST_STEPS,
} from "../consts";
import { getWhilteCurrencyList, getNetWorksWithCurrency } from "../api";

const useAdd = () => {
  const [addressType, setAddressType] = useState(WHITELIST_CATEGORY.UNHOSTED); // 地址类型 钱包/交易所
  const [addressName, setAddressName] = useState(); // 地址名称
  const [currency, setCurrency] = useState(); // 代币
  const [network, setNetwork] = useState(""); // 代币网络
  const [address, setAddress] = useState(); // 钱包地址
  const [whitelistUuid, setWhitelistUuid] = useState();
  const [whitelistVaspDid, setWhitelistVaspDid] = useState("");
  const [usedKeyList, setUsedKeyList] = useState([1, 2]); // 用途
  const { t } = useI18n();
  const [step, setStep] = useState(WHITELIST_STEPS.ADD);
  const [verifyType, setVerifyType] = useState(WHITELIST_AUTH_TYPE.SIGN);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [netWorkOptions, setNetWorkOptions] = useState([]);

  useEffect(() => {
    setCurrency("");
    if (addressType === WHITELIST_CATEGORY.UNHOSTED) {
      setUsedKeyList([1, 2]);
    } else {
      setUsedKeyList([2]);
    }
  }, [addressType]);

  useEffect(() => {
    getCurrentyList();
  }, []);

  useEffect(() => {
    if (currency) {
      getNetWorks(currency);
    }
  }, [currency]);

  const showUsedError = useMemo(() => {
    if (
      usedKeyList.length === 0 &&
      addressType === WHITELIST_CATEGORY.UNHOSTED
    ) {
      return true;
    }
    return false;
  }, [addressType, usedKeyList]);

  const memoCurrencyList = useMemo(() => {
    if (currencyOptions?.length > 0) {
      if (addressType === WHITELIST_CATEGORY.UNHOSTED) {
        return currencyOptions?.filter((d) => d.support?.indexOf("CHAIN") > -1);
      } else {
        return currencyOptions?.filter((d) => d.support?.indexOf("CEX") > -1);
      }
    }
    return [];
  }, [currencyOptions, addressType]);

  const getCurrentyList = async () => {
    const res = await getWhilteCurrencyList({ scene: "whitelist" });
    if (res.code === 0) {
      const list = res.data.currency_list.map((d, i) => {
        return {
          ...d,
          label: d.name,
          value: d.name,
        };
      });
      setCurrencyOptions(list);
    }
  };

  const getNetWorks = async (currency) => {
    const res = await getNetWorksWithCurrency({ currency });
    if (res.code === 0) {
      if (res?.data?.currency_network_info?.length > 0) {
        const nets = res.data.currency_network_info?.map((d) => {
          return {
            ...d,
            label: d.network,
            value: d.network,
          };
        });
        setNetWorkOptions(nets);
      } else {
        setNetWorkOptions([]);
        setNetwork("");
      }
    }
  };

  const addressTypeOptions = useMemo(() => {
    return [
      {
        text: t("mJjedBCPidtXUCYHus"),
        id: WHITELIST_CATEGORY.UNHOSTED,
      },
      {
        text: t("IIbmROzHEYCycsCyk"),
        id: WHITELIST_CATEGORY.HOSTED,
      },
    ];
  }, [t]);

  const verifyMethods = useMemo(() => {
    return [
      {
        text: t("LESgEuOUJYjZQYLUlO"),
        id: WHITELIST_AUTH_TYPE.SIGN,
      },
      {
        text: t("hsgIRJDqXwkPnsmgktga"),
        id: WHITELIST_AUTH_TYPE.TRANSFER,
      },
    ];
  }, [t]);

  const canToNext = useMemo(() => {
    if (!addressName || !currency || !network || !address || showUsedError)
      return false;
    return true;
  }, [addressName, currency, network, address, showUsedError]);

  const memoWhiteUsed = useMemo(() => {
    if (addressType === WHITELIST_CATEGORY.UNHOSTED) {
      return [
        { value: 1, text: t("gTYMvovCwafJTrjdlKg") },
        { value: 2, text: t("PczYwMSUlifZlPdkNj") },
      ];
    }
    // cex 只有提现
    return [{ value: 2, text: t("PczYwMSUlifZlPdkNj") }];
  }, [t, addressType]);

  const handleWhiteUsed = (value) => {
    if (addressType === WHITELIST_CATEGORY.UNHOSTED) {
      const list = [...usedKeyList];
      const findIndex = list.indexOf(value);

      if (findIndex >= 0) {
        list.splice(findIndex, 1);
        setUsedKeyList([...list]);
      } else {
        list.push(value);
        setUsedKeyList([...list]);
      }
    }
  };

  // useEffect(() => {
  //   setAddressName('')
  //   setCurrency('')
  //   setNetwork('')
  //   setAddress('')
  // }, [addressType])

  return {
    addressType,
    setAddressType,
    addressName,
    setAddressName,
    currency,
    setCurrency,
    network,
    setNetwork,
    address,
    setAddress,
    currencyOptions,
    netWorkOptions,
    addressTypeOptions,
    canToNext,
    setStep,
    step,
    verifyMethods,
    verifyType,
    setVerifyType,
    whitelistUuid,
    setWhitelistUuid,
    whitelistVaspDid,
    setWhitelistVaspDid,
    memoWhiteUsed,
    handleWhiteUsed,
    usedKeyList,
    showUsedError,
    setUsedKeyList,
    memoCurrencyList,
  };
};

export { useAdd };
